import React, { useState } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import "../loginstyle/loginPageCss.css";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import PasswordHint from "../components/PasswordHint";
import { ToolTip } from "../../../components/ToolTip";
import InfoIcon from "@material-ui/icons/Info";
import { black500 } from "../../../theme/colors";

export default function CommonInput({
  type = "text",
  label = "",
  value,
  onChange = () => { },
  disabled,
  error = "",
  name = "",
  showToggle = false,
  showHint,
  autoFocus = false,
  inputMode = "text "
}) {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const actualType = type === "password" && showPassword ? "text" : type;

  return (
    <div
      className="input-container"
      style={{ width: "70%", marginTop: "10px" }}>
      <div style={{ position: "relative" }}>
        <input
          type={actualType}
          name={name}
          disabled={disabled}
          inputMode={inputMode}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          autoFocus={autoFocus}
          className={`input-field ${error ? "error" : ""}`}
          style={{
            width: "100%",
            padding: type === "password" ? "10px 46px 10px 12px" : "10px 12px",
            borderRadius: "6px",
            border: error ? "1.5px solid #D93025" : (focused ? "1.5px solid #4770C1" : "1.5px solid #cbd5e1"),
            boxShadow: focused && !error ? "0 0 0 3px rgba(71, 112, 193, 0.15)" : "none",
            color: "#000",
            fontSize: "16px",
            outline: "none",
            backgroundColor: disabled ? "#E9EDF5" : "transparent",
            transition: "all 0.25s ease",
            fontFamily: "barlow",
            cursor: disabled ? "not-allowed" : "text",
          }}
        />

        <label
          style={{
            position: "absolute",
            left: value || focused ? "12px" : "16px",
            top: value || focused ? "-10px" : "10px",
            fontSize: value || focused ? "14px" : "16px",
            color: error ? "red" : "#4770C1",
            pointerEvents: "none",
            backgroundColor: "#ffffff",
            padding: "0 6px",
            fontFamily: "barlow",
            fontWeight: value || focused ? "500" : "400",
            transition: "0.25s ease all",
          }}
        >
          {label}
        </label>

        {type === "password" && showToggle && (
          <div
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",

            }}
          >
            {showPassword ? (
              <VisibilityOffIcon style={{ color: "#4770C1" }} />
            ) : (
              <VisibilityIcon style={{ color: "#4770C1" }} />
            )}
          </div>
        )}

        {showHint && (
          <div
            style={{
              position: "absolute",
              right: "-34px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 2,
            }}
          >
            <ToolTip
              icon={<InfoIcon style={{ color: "#000" }} />}
              content={<PasswordHint />}
            />
          </div>
        )}
      </div>

      {error && (
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            color: "#D93025",
            fontSize: "14px",
            fontFamily: "barlow",
            marginLeft: "1px",
          }}
        >
          <ErrorOutlineIcon style={{ fontSize: "18px", color: "#D93025" }} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
